export const breadCrumbHandler = (pathName, title) => {
    const location = pathName.split("/").slice(1)
    const text = location.map((item, i, arr) => {
        if (i == arr.length - 1 && arr.length > 1) return ({
            text: title,
            slug: `/${arr[0]}/${item}`
        })
        else if (arr.length > 1) return ({ text: item[0].toUpperCase() + item.slice(1), slug: `/${item}` });
        else return ({ text: title, slug: `/${item}` });
    })
    return text
}